import { render, staticRenderFns } from "./ContactDetailForm.vue?vue&type=template&id=08bf4c34&"
import script from "./ContactDetailForm.vue?vue&type=script&lang=js&"
export * from "./ContactDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports